import styled from 'styled-components';
import { Form as FormikForm } from 'formik';

export const Form = styled(FormikForm)`
  gap: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
